import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Paper,

} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import axios from "axios";
import { encryptData } from "../cryptoUtils";
const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: "",
    password: "",

  });
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [authError, setAuthError] = useState("");

  const validate = () => {
    const tempErrors = {};
    if (!formData.email) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Email is not valid";
    }
    if (!formData.password) {
      tempErrors.password = "Password is required";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleTogglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAuthError("");
    if (!validate()) return;
  
    try {
      setSubmitting(true);
      const result = await authenticateUser(formData);
      if (!result.authenticated) {
        setAuthError(result.message || "Login failed");
        return;
      } else {
        login(result.user);
        navigate("/");
      }
    } catch (err) {
      setAuthError(err.message);
    } finally {
      setSubmitting(false);
    }
  };



  const authenticateUser = async ({ email, password }) => {
    try {
      const encryptedPassword = encryptData(password);
      const encryptedEmail = encryptData(email);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/login`,
        {
          email: encryptedEmail,
          password: encryptedPassword,
        },
        { withCredentials: true } // cookie set hone ke liye zaroori
      );

      return {
        authenticated: response.data.success,
        user: response.data.user,
      };
    } catch (error) {
      throw new Error(error.response?.data?.message || "Login failed");
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f4f7fe"
    >
      <Paper
        elevation={2}
        sx={{
          padding: 4,
          width: "100%",
          maxWidth: 400,
          borderRadius: 2,
        }}
      >
        <form onSubmit={handleSubmit} noValidate>
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h5" fontWeight="bold">
              Login
            </Typography>
          </Box>

          <TextField
            size="small"
            label="Email Address"
            name="email"
            type="email"
            fullWidth
            margin="normal"
            value={formData.email}
            onChange={handleChange}
            error={!!errors.email}
            helperText={errors.email}
          />

          <TextField
            size="small"
            label="Password"
            name="password"
            fullWidth
            margin="normal"
            type={showPassword ? "text" : "password"}
            value={formData.password}
            onChange={handleChange}
            error={!!errors.password}
            helperText={errors.password}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleTogglePassword} edge="end">
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />


          {authError && (
            <Typography color="error" variant="body2" mb={1}>
              {authError}
            </Typography>
          )}

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            disabled={submitting}
            sx={{
              mt: 2,
              textTransform: "none",
              fontWeight: "bold",
              backgroundColor: "#006dff",
              "&:hover": {
                backgroundColor: "#0056cc",
              },
            }}
          >
            {submitting ? "Logging in..." : "Login"}
          </Button>
        </form>
      </Paper>


    </Box>
  );
};

export default Login;
